/* eslint-disable no-underscore-dangle */
/** @jsx jsx */
import { useState } from "react"
import { Flex, jsx, Container, Box } from "theme-ui"
import { GatsbyImage } from "gatsby-plugin-image"
import queryString from "query-string"
import { useNavLinks } from "../hooks/useNavLinks"
import Action from "./shared/Action"
import DropdownMenu from "./shared/NavDropdown"
import SecondaryDropdown from "./shared/SecondaryDropdown"
import Link from "./shared/Link"

const Nav = ({ navName }) => {
  const { contentfulMainNav } = useNavLinks(navName ? navName : "great_expectations")
  const { links, logo } = contentfulMainNav
  let queryParams = ""
  if (typeof window !== "undefined") {
    queryParams = queryString.parse(window.location.search)
  }
  const { banner } = queryParams
  const [activeDropdown, setActiveDropdown] = useState(null)
  return (
    <Container
      as="nav"
      sx={{
        display: ["none", "none", "none", "none", "flex"],
        flexDirection: "row",
        height: "96px",
        justifyContent: "space-between",
        alignItems: "center",
        paddingRight: "20px",
      }}
      className="main-nav"
    >
      <Box sx={{ maxWidth: "210px" }} className="nav-logo">
        <Link to={banner ? "/" + "?banner=" + banner : "/"}>
          <GatsbyImage image={logo.gatsbyImageData} alt={logo.description} />
        </Link>
      </Box>
      <Flex as="ul">
        {links.map((link) =>
          link.__typename === "ContentfulNavDropdown" ? (
            link.dropdownMainLink ? (
              <Box as="li" key={link.id} sx={{ variant: "navListItem", alignItems: "center" }}>
                <SecondaryDropdown isFirstLevel={true} key={link.id} dropdown={link} />
              </Box>
            ) : (
              <Box as="li" key={link.id} sx={{ variant: "navListItem" }}>
                <DropdownMenu
                  key={link.id}
                  links={link}
                  isActive={activeDropdown === link.id}
                  setActiveDropdown={(id) => setActiveDropdown(id)}
                />
              </Box>
            )
          ) : (
            <Box as="li" key={link.id} sx={{ variant: "navListItem", paddingInline: "20px", alignItems: "center" }}>
              <Action
                key={link.id}
                label={!link.icon && (!link.style ? link.label.toUpperCase() : link.label)}
                url={link.url}
                icon={link.icon}
                classname={link.classname}
                actionEvent={link.actionEvent}
                form={link.form}
                hubspotForm={link.hubspotForm}
                style={link.style || "navLink"}
                iconSize={link.iconSize}
                aria-label={link.icon && link.label}
                fontsize="14px"
                paddingCustom={!link.style && "5px 0"}
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              />
            </Box>
          ),
        )}
      </Flex>
    </Container>
  )
}

export default Nav
